import React, {useState} from "react";
import MatrixFields from "./MatrixFields";
import GeneralUserSettings from "./GeneralUserSettings";
import {Box, Tab, Tabs, Typography} from "@material-ui/core";
import PropTypes from 'prop-types';
import t from "../../../helpers/t";
import {ADJUSTMENT_HELP_TEXT, HtmlTooltip} from "../../../../utils/HelperOld";

const UserSettings = (props) => {
    const {setting,matrixFields,setMatrixFields,dispatch,onChange,_showPopUp,showChangeView,subPanel} = props;
    const [value, setValue] = useState(Number(subPanel));
    const handleChange = (event,newValue) => {
        setValue(newValue);
    };
    return (<>
        <>
            <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
                <Tabs value={value} onChange={handleChange} aria-label="setting tabs">
                    <Tab label={t('general')} {...a11yProps(0)} />
                    <Tab label={t('user fields backoffice')} {...a11yProps(1)} />
                    <Tab label={t('user fields frontends')} {...a11yProps(2)} />
                </Tabs>
            </Box>
            <TabPanel value={value} index={0}>
                <GeneralUserSettings
                    setting={setting}
                    onChange={onChange}
                    _showPopUp={_showPopUp}
                />
            </TabPanel>
            <TabPanel value={value} index={1}>
                <div className='fieldBox' style={{width:"98%"}}>
                    <label className="inb-form__controlLabel legendLabel">
                        <HtmlTooltip title={<React.Fragment>{<ADJUSTMENT_HELP_TEXT content={t('Nutzerfelder im Backoffice', null, 'capital')+'::'+t('admin_fields_info')+"//"}/>}</React.Fragment>}>
                            <a>
                                <i className="inb-ico fi fi-info"> {t('info', null, 'capital')}</i>
                            </a>
                        </HtmlTooltip>
                    </label>
                <MatrixFields
                    matrixFields={matrixFields}
                    type='admin'
                    setMatrixFields={setMatrixFields}
                    dispatch={dispatch}
                    subpanel={1}
                    showChangeView={showChangeView}
                />
                </div>
            </TabPanel>
            <TabPanel value={value} index={2}>
                <div className='fieldBox' style={{width:"98%"}}>
                    <label className="inb-form__controlLabel legendLabel">
                        <HtmlTooltip title={<React.Fragment>{<ADJUSTMENT_HELP_TEXT content={t('Nutzerfelder im Frontend/App', null, 'capital')+'::'+t('user_fields_info')+"//"}/>}</React.Fragment>}>
                            <a>
                                <i className="inb-ico fi fi-info"> {t('info', null, 'capital')}</i>
                            </a>
                        </HtmlTooltip>
                    </label>
                <MatrixFields
                    matrixFields={matrixFields}
                    type='user'
                    setMatrixFields={setMatrixFields}
                    showChangeView={showChangeView}
                    subpanel={2}
                    dispatch={dispatch}
                />
                </div>
            </TabPanel>
        </>

    </>)
}

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}
TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default UserSettings;